import { useEffect, useState } from 'react'
import UpgradeToProModal, { GENERIC_PAYWALL_SUBTITLE } from './UpgradeToProModal.jsx'
import { UPGRADE_REQUIRED_EVENT } from '../services/api.js'

/**
 * The upgrade prompt for a refusal nobody on the page was waiting for.
 *
 * The API client fires UPGRADE_REQUIRED_EVENT on any 402, from whichever of its callers tripped
 * it. Pages that know their own limit (opens, searches, reinventions) open UpgradeToProModal
 * themselves with copy about that limit; this catches everything else, so a refusal always
 * lands as an offer over the page rather than a raw error or a trip to another screen.
 */
export default function GlobalUpgradePrompt() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const show = () => setOpen(true)
    window.addEventListener(UPGRADE_REQUIRED_EVENT, show)
    return () => window.removeEventListener(UPGRADE_REQUIRED_EVENT, show)
  }, [])

  return (
    <UpgradeToProModal
      isOpen={open}
      onClose={() => setOpen(false)}
      subtitle={GENERIC_PAYWALL_SUBTITLE}
    />
  )
}
